enum ProductCardLayoutEnum {
	list = 'list',
	gallery = 'gallery',
	information = 'information'
}
export default ProductCardLayoutEnum;
